// theme-sources/js/core-ui/components/mobile-search.js

import { sectionLogger } from "./_logger";

const DEBUG = true;
const logger = sectionLogger("MobileSearch", DEBUG);

class MobileSearch extends HTMLElement {
  constructor() {
    super();
    this.openBtn = document.querySelector("[data-mobile-search-open]");
    this.closeBtn = document.querySelector("[data-mobile-search-close]");
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }

  connectedCallback() {
    this.openBtn?.addEventListener("click", this.open);
    this.closeBtn?.addEventListener("click", this.close);
  }

  open() {
    document.body.classList.add("is-mobile-search-open");
    const input = document.querySelector("[data-predictive-input]");
    setTimeout(() => input?.focus(), 50);
  }

  close() {
    document.body.classList.remove("is-mobile-search-open");

    const input = document.querySelector("[data-predictive-input]");
    const predictive = document.querySelector("predictive-search");

    if (input) {
      input.value = "";
      input.dispatchEvent(new Event("input", { bubbles: true }));
    }

    predictive?.close();
  }
}

if (!customElements.get("mobile-search")) {
  customElements.define("mobile-search", MobileSearch);
}
